export enum InvitationStatusEnum {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  COMPLETED = 'COMPLETED',
  RATED = 'RATED'
}

export interface InvitationModel {
  id: number;
  fromUserId: number;
  toUserId: number;
  courtId: number;
  chatId: number;
  status: InvitationStatusEnum;
  batchId: string;
  fromUsername: string
  fromUserImageUrl: string
  toUsername: string
  toUserImageUrl: string
  openMatchId: number;
}

export interface UpdateInvitationStatusRequestModel {
  invitationStatus: InvitationStatusEnum;
  invitationId: number;
}

export interface SendInvitationRequestModel {
  toUserIds: number[];
  courtId: number;
  openMatchId: number;
}

export interface ChangeChatInInvitationRequestModel {
  chatId: number;
  invitationId: number;
}

export interface GetInvitationsRequestModel {
  invitationStatus: InvitationStatusEnum;
}